module.exports = __webpack_public_path__ + "static/media/planning1@3x.7ad96890.png";